import React from "react";
import { Dialog, Stack, Typography, IconButton, Button, colors } from "@mui/material";
import { CloseIcon, SuccessIcon } from "@app/theme/overrides/CustomIcons";
import { Strings } from "@app/constants";

type Props = {
  open: boolean;
  onClose: () => void;
};

const BookingSuccessDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          px: { xs: 2, sm: 4 },
          py: { xs: 3, sm: 4 },
          textAlign: "center",
        },
      }}
    >
      <Stack alignItems="flex-end">
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <Stack alignItems="center" spacing={2}>
        <SuccessIcon
          sx={{
            fontSize: 64,
            color: colors.blue[600],
          }}
        />

        <Typography variant="h5" fontWeight={600}>
          {Strings.buy.requestReceived}
        </Typography>

        <Typography
          color="text.secondary"
          sx={{
            maxWidth: 420,
            fontSize: { xs: 13, sm: 14 },
            lineHeight: 1.6,
          }}
        >
          {Strings.buy.thankYouFor}
        </Typography>

        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            mt: 2,
            px: 5,
            py: 1.2,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {Strings.button.close}
        </Button>
      </Stack>
    </Dialog>
  );
};

export { BookingSuccessDialog };
